
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('HOME_MEDIAS_ALL').plugin(axiosPlugin, {template: "array"});

let fetchHomeMediasAllAction = redux.fetchActionGet();

export const fetchHomeMediasAll = () => fetchHomeMediasAllAction(`/features/medias-no-creator`);

export const homeMediaAll = redux.reducer();